<template>
  <div id="home-center" ref="appRef">
    <div class="host-body">
      <!-- 时间 -->
      <!-- <div class="time-box">
        <i class="el-icon-time"></i>
        <span class="text">{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span>
      </div> -->

      <div class="body-box">
        <div class="content-top">
          <div class="num-top d-flex">
            <div class="">
              <div class="type-name">学校</div>
              <div>
                <div
                  class="num-card"
                  v-for="(item, i) in schoolNum.length"
                  :key="i"
                  v-text="schoolNum.charAt(i)"
                ></div>
                <span class="unit">所</span>
              </div>
            </div>
            <div class="">
              <div class="type-name">老师</div>
              <div>
                <div
                  class="num-card"
                  v-for="(item, i) in teacherNum.length"
                  :key="i"
                  v-text="teacherNum.charAt(i)"
                ></div>
                <span class="unit">人</span>
              </div>
            </div>
          </div>
          <div class="sex-box">
            <div class="box-title">男女教师比例</div>
            <SexChart :cdata="teacherSexData" />
          </div>
        </div>
        <div class="content-bottom">
          <div class="bottom-left">
            <dv-border-box-13 :color="['#1b60cc', '#17caf0']">
              <div class="box-title">资源文件上传数量统计</div>
              <FileChart :cdata="fileData" />
            </dv-border-box-13>
          </div>
          <div class="bottom-right">
            <dv-border-box-12 :color="['#1b60cc', '#17caf0']">
              <div class="box-title">学校设备数量统计</div>
              <DeviceChart :cdata="deviceData" />
            </dv-border-box-12>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import drawMixin from '@/utils/drawMixin';
// import { formatTime } from '@/utils/index.js';
import SexChart from '_c/echart/center/topRightChart/chart.vue';
import FileChart from '_c/echart/center/bottomLeftChart/chart.vue';
import DeviceChart from '_c/echart/center/bottomRightChart/chart.vue';

import {
  getSchoolTotal,
  getTeacherTotal,
  getFileNums,
  getDeviceNums
} from '@/api/center.js';

export default {
  components: {
    SexChart,
    FileChart,
    DeviceChart
  },
  // mixins: [drawMixin],
  data() {
    return {
      schoolNum: '0',
      teacherNum: '0',
      teacherSexData: {
        total: '0',
        data: [
          { value: 0, name: '男' },
          { value: 0, name: '女' }
        ]
      },
      fileData: {
        xAxisData: [
          '评估资源',
          '课程资源',
          '特色课程',
          '教学具/辅具资源',
          '常用表格'
        ],
        seriesData: []
      },
      deviceData: {
        xAxisData: [
          // '设备1',
          // '设备2',
          // '设备3',
        ],
        seriesData: []
      }
    };
  },
  async created() {
    // await this.countyMine();
  },
  mounted() {
    this.initData();
  },

  methods: {
    /**
     * 初始化数据
     */
    initData() {
      this.getSchoolNum();
      this.getTeacherTotalNum();
      this.getResourceFileNums();
      this.getDevices();
    },

    // 学校总数
    async getSchoolNum() {
      const { data } = await getSchoolTotal();
      this.schoolNum = data.count + '';
    },
    // 教师总人数
    async getTeacherTotalNum() {
      const { data } = await getTeacherTotal();
      if (data.manCount === 0 && data.womanCount === 0) {
        return;
      }
      this.teacherNum = data.allCount + '';
      this.teacherSexData = {
        total: data.allCount,
        data: [
          { name: '男', value: data.manCount },
          { name: '女', value: data.womanCount }
        ]
      };
    },
    // 资源文件数量
    async getResourceFileNums() {
      const { data } = await getFileNums();
      if (!Array.isArray(data)) return;
      // let typeMap = {
      //   CommonTables: '常用表格',
      //   Assessment: '评估资源',
      //   Course: '课程资源',
      //   SpecialCourse: '特色课程',
      //   TeacherResource: '教学具/辅具'
      // };
      let sortArr = [
        'Assessment',
        'Course',
        'SpecialCourse',
        'TeacherResource',
        'CommonTables'
      ];
      this.fileData.seriesData = sortArr.map((type) => {
        let item = data.find((item) => item.type === type);
        if (item) {
          return item.count;
        } else {
          return 0;
        }
      });
    },
    // 设备数量
    async getDevices() {
      const { data } = await getDeviceNums();
      if (!Array.isArray(data)) return;

      this.deviceData.xAxisData = data.map((item) => item.type);
      this.deviceData.seriesData = data.map((item) => item.count);
    }
  }
};
</script>

<style lang="scss" scoped>
#home-center {
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  // transform-origin: left top;

  color: #d3d6dd;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  // background-color: #0a1531;

  .host-body {
    padding-top: 170px;

    .time-box {
      width: 538px;
      text-align: center;
      font-size: 26px;
      color: #ffffff;
      i {
        margin-right: 20px;
      }
    }
    $borderColor: #17caf0;
    .body-box {
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      .box-title {
        color: #2accff;
        font-size: 35px;
        padding-top: 30px;
        text-align: center;
      }
      .content-top {
        display: flex;
        align-items: center;
        .num-top {
          margin-top: 30px;
          justify-content: space-around;
          width: 1420px;
          height: 220px;
          color: #fff;
          font-size: 24px;
          font-weight: bolder;
          .num-card {
            display: inline-block;
            width: 50px;
            height: 67px;
            background: linear-gradient(0deg, #06296a, rgba(6, 41, 106, 0));
            border: 1px solid rgba(0, 182, 255, 0.8);
            border-radius: 3px;
            line-height: 67px;
            text-align: center;
            color: #fdcc00;
            font-size: 50px;
            // background-color: #08266f;
            margin-right: 10px;
            margin-top: 20px;
          }
          .unit {
            vertical-align: bottom;
          }
        }
        .sex-box {
          width: 520px;
          background-image: url(~@/assets/images/right-bottom-border1.png);
          background-size: 100% 100%;
        }
      }
      .content-bottom {
        padding-top: 30px;
        display: flex;
        .bottom-left {
          width: 1390px;
          margin-right: 30px;
        }
        .bottom-right {
          width: 520px;
        }
      }
    }
  }
}
</style>
